/* eslint-disable react/no-unused-prop-types */
/* eslint-disable max-len */
/* eslint jsx-a11y/no-static-element-interactions: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router';
import { replace } from 'react-router-redux';
import { withTranslation } from 'react-i18next';
import {
  Button,
  Checkbox,
  Dimmer,
  Grid,
  Header,
  Icon,
  Label,
  Loader,
  Table,
  Item,
} from 'semantic-ui-react';
import moment from 'moment-timezone';
import qs from 'qs';
import _ from 'lodash';
import config from '../../config';
import LoanAmount from './LoanAmount';
import PageNav from './PageNav';
import SearchFilter from './SearchFilter';
import { SelectListMultiple, SelectList } from './Filters';
import SortButton from './SortButton';
import SizeSuffix from './SizeSuffix';
import FixedBarStatus from './FixedBarStatus';
import CurrencySymbol from './CurrencySymbol';
import {
  UNIT_STATUSES_HQ_BASIC,
  UNIT_STATUSES_DE_BASIC,
  UNIT_STATUSES_SIMPLE_MODE,
  UNIT_STATUSES_SIMPLE_ALL,
} from '../constants/unitStatuses';
import BUMI_FILTER from '../constants/bumiFilter';
import { flashErrorMessage, flashSuccessMessage } from '../actions/flash';
import { fetchM, serverRequestPut } from '../actions/fetchM';
import { fetchProjectUnitSpecifications } from '../actions/projectUnitSpecifications';
import { spaFullNumber } from '../utils/amount';
import isNumber from '../utils/numbers/isNumber';
import { titleCase } from '../utils/strings';
import { decodeSearch, encodeSearch } from '../utils/url';
import { getItem, setItem } from '../utils/storage';
import DeleteConfirm from '../containers/modals/DeleteConfirm';
import { namespaces, TRANSLATION_FILES } from '../constants/translation';
import { getAreaLabel, getAreaSortLabels } from '../utils/areaLabel';
import {
  isVietnamCompany,
  showsUnitQuotaFilter,
  unitQuotaChipLabel,
  unitQuotaFilterOptions,
  unitQuotaFilterPlaceholder,
} from '../utils/vietnam';

class ProjectUnitsList extends Component {
  static propTypes = {
    notFoundNode: PropTypes.node,
    unitOnClick: PropTypes.func,
    unitOnCheck: PropTypes.func,
    headerNode: PropTypes.func,
    footerNode: PropTypes.func,
    selected: PropTypes.string,
    projectID: PropTypes.string.isRequired,
    unitLayoutID: PropTypes.string,
    where: PropTypes.shape({
      limit: PropTypes.number,
    }),
    toggleable: PropTypes.bool,
    addPath: PropTypes.string,
    onAdd: PropTypes.func,
    projectUnitSpecifications: PropTypes.shape({
      data: PropTypes.array,
    }),
    auth: PropTypes.shape({
      isBranchLeader: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      allowEditUnitPrice: PropTypes.bool,
      allowEditUnitDetails: PropTypes.bool,
      company: PropTypes.shape({
        countryCode: PropTypes.string,
      }),
    }),
    location: PropTypes.shape({
      pathname: PropTypes.string,
      query: PropTypes.object,
      search: PropTypes.string,
    }),
    hideNew: PropTypes.bool,
    t: PropTypes.func,
    project: PropTypes.shape({
      siteplanSettings: PropTypes.shape({
        salesChartSimpleMode: PropTypes.bool,
        siteplanSimpleMode: PropTypes.bool,
        unitListDisableClickUnavailable: PropTypes.bool,
      }),
      activeBookingsInUnits: PropTypes.bool,
    }),
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
    projectUnitSpecifications: state.projectUnitSpecifications,
  })
  static getPropsToState = (props) => {
    const projectUnitSpecifications = props.projectUnitSpecifications ?
      [].concat(props.projectUnitSpecifications.data) : [];
    const options = projectUnitSpecifications.map(d => ({
      text: titleCase(d.name),
      value: d.id,
      description: d.shortName,
    })) || [];
    const windowWidth = window.innerWidth;
    const isMobile = windowWidth < 768;
    let row = 9;
    switch (true) {
      case windowWidth < 442:
        row = 2; break;
      case windowWidth < 553:
        row = 3; break;
      case windowWidth < 665:
        row = 4; break;
      case windowWidth < 768:
        row = 5; break;
      case windowWidth < 992:
        row = 6; break;
      case windowWidth < 1200:
        row = 8; break;
      default:
        row = 9;
    }
    const query = decodeSearch(props.location.search);
    const currentPage = parseInt(query.page, 10) || 1;
    const search = query.search || '';
    const unitStatus = query.unitStatus || [];
    const isBumi = query.isBumi || '';
    const bookingsBy = query.bookingsBy || '';
    let facilities = [];
    let globalSettings = {};

    const storedFacilities = getItem(`${config.get('appName')}.project_${props.projectID}.facilities`);
    if (storedFacilities) {
      try {
        facilities = JSON.parse(storedFacilities).data || [];
      } catch (e) {
        Bugsnag.notifyException(e);
      }
    }

    const storeGlobalSettings = getItem(`${config.get('appName')}.globalSettings`);
    if (storeGlobalSettings) {
      try {
        globalSettings = JSON.parse(storeGlobalSettings).data || [];
      } catch (e) {
        Bugsnag.notifyException(e);
      }
    }
    const returnStates = {
      options,
      projectUnitSpecifications,
      isMobile,
      row,
      currentPage,
      search,
      unitStatus,
      facilities,
      isBumi,
      bookingsBy,
      globalSettings,
    };
    if (
      (facilities && facilities.length > 0) ||
      (isBumi !== '') ||
      (bookingsBy !== '')
    ) {
      returnStates.advanceFilter = true;
    }
    return returnStates;
  }
  static summaryDefault = {
    count: 0,
    newCount: 0,
    reservedCount: 0,
    bookedCount: 0,
    developerBookedCount: 0,
    delistCount: 0,
    soldCount: 0,
    developerReservedCount: 0,
    developerSoldCount: 0,
  }
  constructor(props) {
    super(props);
    const state = ProjectUnitsList.getPropsToState(props);
    const summary = Object.assign({}, ProjectUnitsList.summaryDefault);
    this.state = {
      hasMore: false,
      token: '',
      count: 0,
      limit: 0,
      offset: 0,
      data: [],
      summary,
      advanceFilter: false,
      showDeleteConfirm: false,
      deleteUnitData: null,
      mpToggleLoading: false,
      oriData: [],
      ...state,
    };
    this.debouncedMPToggle = _.debounce(this.setUnitPublishToMP, 700);
  }
  componentWillMount() {
    const { store } = this.context;
    store.dispatch(fetchProjectUnitSpecifications());
  }
  componentDidMount() {
    const query = decodeSearch(this.props.location.search);
    if (!isNumber(query.page) || query.page <= 0) {
      delete query.page;
    }
    this.replaceQuery(query);
    window.addEventListener('resize', this.handleResize, false);
  }
  componentWillReceiveProps(nextProps) {
    const state = ProjectUnitsList.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }
  setUnitPublishToMP = async (projectUnit = {}) => {
    const { store } = this.context;
    const { t } = this.props;
    const { id, projectID } = projectUnit;
    if (!id && !projectID) {
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }
    try {
      await serverRequestPut(
        `/projects/${projectID}/units/${id}/`,
        store,
        this.state.token,
        { isPublishedToMP: projectUnit.isPublishedToMP },
      );
      store.dispatch(flashSuccessMessage({
        header: t('Update Success', { ns: TRANSLATION_FILES.translation }),
        message: t(`Unit {{reference}} was successfully ${projectUnit.isPublishedToMP ? 'listed' : 'unlisted'} in Marketplace`, { reference: projectUnit.reference, ns: TRANSLATION_FILES.translation }),
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setState({
        data: _.cloneDeep(this.state.oriData),
      });
    }
    this.setState({
      mpToggleLoading: false,
    });
  }
  getStatusCount = (status) => {
    const { summary } = this.state;
    if (this.state.loading) {
      return '...';
    }
    switch (status) {
      case 'total':
        return summary.count;
      case 'new':
        return summary.newCount;
      case 'reserved':
        return summary.reservedCount + summary.developerReservedCount;
      case 'booked':
        if (this.hasAccess()) {
          return summary.bookedCount + summary.developerBookedCount;
        }
        return summary.bookedCount + summary.developerBookedCount +
        summary.soldCount + summary.developerSoldCount;
      case 'delist':
        return summary.delistCount;
      case 'sold_spa_signed':
        return summary.soldCount + summary.developerSoldCount;
      case 'unavailable':
        return summary.unavailableCount;
      default:
        return 0;
    }
  }
  getRowClassName = (statusID) => {
    if (statusID) {
      if (!this.hasAccess()) {
        if (statusID === 'sold_spa_signed' || statusID === 'developer_sold') {
          return 'row-colors unit_row_booked';
        }
      }
      return `row-colors unit_row_${statusID}`;
    }
    return 'row-colors';
  }
  getLabelClassName = (statusID) => {
    if (!this.hasAccess()) {
      if (statusID === 'sold_spa_signed' || statusID === 'developer_sold') {
        return 'booked';
      }
    }
    return statusID;
  }
  getUnitStatuses = () => {
    if (this.hasAccess()) {
      return this.translateStatuses(UNIT_STATUSES_HQ_BASIC);
    }
    if (this.hasSimpleViewMode()) {
      return this.translateStatuses(UNIT_STATUSES_SIMPLE_MODE);
    }
    return this.translateStatuses(UNIT_STATUSES_DE_BASIC);
  }
  setUnits(data = []) {
    return new Promise((res) => {
      this.setState({
        data: data || [],
      }, () => {
        res(data);
      });
    });
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  hasSimpleViewMode = () => {
    const { project } = this.props;
    const user = this.props.auth;
    if (!user.isHeadquarters && !user.isSuperAdmin && !user.isBranchLeader) {
      return project && project.siteplanSettings && (project.siteplanSettings.salesChartSimpleMode || project.siteplanSettings.siteplanSimpleMode);
    }
    return false;
  }
  translateStatuses = (statuses) => {
    const { t } = this.props;
    return statuses.map(s => ({
      ...s,
      text: t(s.text, { ns: TRANSLATION_FILES.constants }),
    }));
  }
  async fetchProjectUnits(q = {}) {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    const query = Object.assign(q, this.props.where || {}, {
      projectUnitLayoutID: this.props.unitLayoutID || null,
    });
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${this.props.projectID}/units/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const token = res.headers.get('X-Csrf-Token');
      const count = parseInt(res.headers.get('M-Data-count'), 10);
      const limit = parseInt(res.headers.get('M-Data-limit'), 10);
      const offset = parseInt(res.headers.get('M-Data-offset'), 10) || 0;
      const data = await res.json();
      await this.setUnits(data);
      this.setState({
        oriData: _.cloneDeep(data),
      });

      const hasMore = this.state.data.length === limit ?
      this.state.data.length + offset !== count : false;
      if (this.state.data.length < 1 && query.page > 1) {
        const que = decodeSearch(this.props.location.search);
        que.page = 1;
        this.replaceQuery(que);
      } else {
        // handle token.. etc
        await this.setComponentState({
          token,
          count,
          limit,
          offset,
          hasMore,
        });
      }
    }
    await this.setLoading(false);
  }
  async fetchProjectUnitSummaries(q = {}) {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    const query = Object.assign(q, this.props.where || {}, {
      projectUnitLayoutID: this.props.unitLayoutID || null,
    });
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${this.props.projectID}/units/summary/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      await this.setLoading(false);
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const summary = await res.json();
      // handle token.. etc
      await this.setComponentState({ summary });
    }
  }
  async deleteUnit(unitData) {
    const { t } = this.props;
    const { store } = this.context;
    await this.setState({ loading: true });
    try {
      await store.dispatch(fetchM(`/projects/${this.props.projectID}/units/${unitData.id}/`, {
        credentials: 'include',
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.state.token,
        },
      }));
    } catch (err) {
      await this.setState({ loading: false });
      Bugsnag.notifyException(err);
      if (err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
    }
    await this.setState({ loading: false });
    store.dispatch(replace(`/projects/${this.props.projectID}/`));
    store.dispatch(flashSuccessMessage({
      header: t('Delete Success', { ns: TRANSLATION_FILES.translation }),
      message: t('Unit {{reference}} was successfully deleted', { reference: unitData.reference, ns: TRANSLATION_FILES.translation }),
    }));
  }
  adjustRow = (windowWidth) => {
    switch (true) {
      case windowWidth < 442:
        return 2;
      case windowWidth < 553:
        return 3;
      case windowWidth < 665:
        return 4;
      case windowWidth < 768:
        return 5;
      case windowWidth < 992:
        return 6;
      case windowWidth < 1200:
        return 8;
      default:
        return 9;
    }
  }
  hasAccess(check = false) {
    const user = this.props.auth;
    if (this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) {
      return true;
    }
    if (this.props.auth.isBranchLeader &&
      (this.state.data && this.state.data.length > 0) &&
      (this.state.data[0].project.maOwnerCompanyBranchID === user.companyBranch.id)
    ) {
      return true;
    }
    return check;
  }
  isHQorSuperAdmin = () => this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin
  handleResize = () => {
    const state = {};
    const windowWidth = window.innerWidth;
    const isMobile = windowWidth < 768;
    if (isMobile !== this.state.isMobile) {
      state.isMobile = isMobile;
    }
    const row = this.adjustRow(windowWidth);
    if (row !== this.state.row) {
      state.row = row;
    }
    this.setState({ ...state });
  }
  replaceQuery(query, resetPage = false) {
    const { store } = this.context;
    const { pathname } = this.props.location;
    const queryNew = query;
    if (resetPage) {
      queryNew.page = 1;
    }
    this.fetchProjectUnits(queryNew);
    this.fetchProjectUnitSummaries(queryNew);
    store.dispatch(replace(`${pathname}?${encodeSearch(queryNew)}`));
  }
  handleChangePage = (currentPage) => {
    const query = decodeSearch(this.props.location.search);
    query.page = currentPage;
    this.setState({
      currentPage,
    });
    this.replaceQuery(query);
  }
  changeColor = (unit) => {
    if (this.handleOnCheck(unit)) {
      if (unit.statusID === 'reserved' && unit.projectUnitBookingSummary.reservedCount >= unit.project.bookingUnitLimit) {
        return 'yellow';
      }
      return this.statusColor(unit.statusID);
    } else if (this.props.selected && this.props.selected === unit.id) {
      return 'green';
    }
    return null;
  }
  handleOnClick = (e, unit) => {
    if (this.props.unitOnClick) {
      this.props.unitOnClick(e, { unit });
    }
  }
  handleOnCheck = (unit) => {
    if (this.props.unitOnCheck) {
      return this.props.unitOnCheck({ unit });
    }
    return false;
  }
  hasClickAccess = (statusID) => {
    const { project } = this.props;
    if (this.hasSimpleViewMode() && project && project.siteplanSettings && project.siteplanSettings.unitListDisableClickUnavailable && statusID === 'unavailable') {
      return false;
    }
    return true;
  }
  handleOnAdd = (e) => {
    if (this.props.onAdd) {
      this.props.onAdd(e);
    }
  }
  handleSortData = (sortColumn, sortDirection) => {
    const query = decodeSearch(this.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;
    this.replaceQuery(query, true);
  }
  handleClearFilter = (...queryArray) => {
    let hasQuery = false;
    const query = decodeSearch(this.props.location.search);
    const filterArray = [...queryArray];
    filterArray.forEach((filter) => {
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
      }
      if (filter === 'facilities') {
        setItem(`${config.get('appName')}.project_${this.props.projectID}.facilities`, JSON.stringify({
          data: [],
          createdAt: moment().toDate(),
          version: config.get('version'),
        }));
        hasQuery = true;
      }
      if (queryArray.length < 2) {
        this.setState({ advanceFilter: false });
      }
    });
    if (hasQuery) {
      this.replaceQuery(query, true);
    }
  }
  handleFilterOnChange = (value, queryName) => {
    const query = decodeSearch(this.props.location.search);
    if (queryName === 'facilities') {
      setItem(`${config.get('appName')}.project_${this.props.projectID}.facilities`, JSON.stringify({
        data: value,
        createdAt: moment().toDate(),
        version: config.get('version'),
      }));
    } else {
      query[queryName] = value;
    }
    this.replaceQuery(query, true);
  }
  handleReplaceStatus = (status = '') => {
    const query = decodeSearch(this.props.location.search);
    query.unitStatus = [];
    if (status !== '') {
      query.unitStatus.push(status);
    }
    this.replaceQuery(query);
  }
  handleSetAdvanceFilter = (advanceFilter) => {
    this.setState({
      advanceFilter,
    });
  }
  cellCheckSorted(column) {
    const { sortColumn, sortDirection } = decodeSearch(this.props.location.search);
    if (column === sortColumn) {
      return sortDirection === 'asc' ? 'ascending' : 'descending';
    }
    return null;
  }
  handleCellSort = (column) => {
    const { sortColumn, sortDirection } = decodeSearch(this.props.location.search);
    let direction = 'asc';
    if (column === sortColumn) {
      direction = sortDirection === 'asc' ? 'desc' : 'asc';
    }
    this.handleSortData(column, direction);
  }
  checkStatusID = (unit) => {
    const { t } = this.props;
    switch (unit.statusID) {
      case 'developer_reserved':
        return t('Reserved', { ns: TRANSLATION_FILES.constants });
      case 'developer_booked':
        return t('Booked', { ns: TRANSLATION_FILES.constants });
      case 'developer_sold':
      case 'sold_spa_signed':
        return t(this.hasAccess() ? 'Sold' : 'Booked', { ns: TRANSLATION_FILES.constants });
      case 'new':
        return t('Available', { ns: TRANSLATION_FILES.constants });
      case 'unavailable':
        return t('Unavailable', { ns: TRANSLATION_FILES.constants });
      default:
        return t(unit.status.name, { ns: TRANSLATION_FILES.constants });
    }
  }
  handleCancelDelete = (e) => {
    e.preventDefault();
    this.setState({
      showDeleteConfirm: false,
    });
  }
  handleConfirmDelete = (e) => {
    e.preventDefault();
    this.setState({
      showDeleteConfirm: false,
    }, () => {
      this.deleteUnit(this.state.deleteUnitData);
    });
  }
  handleDelete = (e, data) => {
    e.preventDefault();
    this.setState({
      showDeleteConfirm: true,
      deleteUnitData: data,
    });
  }
  handleMPToggle = (toggleData, unitID) => {
    const { data } = this.state;
    const index = data.findIndex(unit => unit.id === unitID);
    if (index !== -1) {
      data[index].isPublishedToMP = toggleData.checked;
      this.setState({
        data,
        mpToggleLoading: true,
      });
    }
  }
  canDelete = (data) => {
    if (data.projectUnitBookingSummary) {
      if (data.projectUnitBookingSummary.totalCount < 1) return true;
    }
    return false;
  }
  isUnitAvailable = () => {
    const { data } = this.state;
    return data.some(unit => unit.statusID === 'new');
  }
  isProjectPublishToMP = () => {
    const { data } = this.state;
    return data.some(unit => unit.project.marketplaceIsPublish || unit.project.marketplaceBuyerIsPublish);
  }
  hasVirtualTour = () => {
    const { data } = this.state;
    return data.some(unit => unit.virtualTourURL !== '' || (unit.projectUnitLayout && unit.projectUnitLayout.virtualTourURL !== ''));
  }
  countActiveBooking = (unit) => {
    let activeBookingCount = 0;
    const bookingSummary = unit.projectUnitBookingSummary;
    if (bookingSummary) {
      activeBookingCount = bookingSummary.reservedCount + bookingSummary.bookedCount + bookingSummary.soldCount;
    }
    if (unit.project && unit.project.activeBookingsIncludeWaitlist) {
      activeBookingCount += bookingSummary.cancelledAvailabilityCount;
    }
    return activeBookingCount;
  }
  renderLabel = (label, idx, props) => {
    const content = this.state.projectUnitSpecifications.find(s =>
      s.id === label.value).shortName;
    return ({
      content,
      ...props,
    });
  }
  renderLegend() {
    const { t } = this.props;
    return (
      <Grid
        columns="equal"
        textAlign="left"
        verticalAlign="middle"
        style={{ margin: '0 0 -1em 0' }}
      >
        <Grid.Row style={{ padding: 0, marginBottom: '0.25em' }}>
          <Grid.Column
            style={{ padding: '0.5em 0', fontSize: '14px' }}
          >
            <a
              onClick={(event) => {
                event.preventDefault();
                this.handleReplaceStatus();
              }}
            >
              <span style={{ fontWeight: 'bold' }}>{`${t('Total units')}:`}</span> {this.getStatusCount('total')}
            </a>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row style={{ padding: 0 }}>
          {
            this.getUnitStatuses().map((status, key) => (
              <FixedBarStatus
                key={key}
                status={status.value}
                name={status.text}
                count={this.getStatusCount(status.value)}
                onClick={this.handleReplaceStatus}
              />
            ))
          }
        </Grid.Row>
      </Grid>
    );
  }
  renderBody() {
    const {
      data,
      facilities,
      isMobile,
      loading,
      mpToggleLoading,
      projectUnitSpecifications,
    } = this.state;
    const { project, t } = this.props;
    const isVietnam = isVietnamCompany(this.props.auth);
    const queryParams = new URLSearchParams(window.location.search);
    const source = queryParams.get('source');
    return (
      data.length > 0 ?
      data.map((unit, idx) => (
        <Table.Row
          key={idx}
          disabled={this.handleOnCheck(unit)}
          className={this.getRowClassName(unit.statusID)}
        >
          <Table.Cell collapsing>
            <Label
              empty circular
              className={this.getLabelClassName(unit.statusID)}
            />
          </Table.Cell>
          <Table.Cell>
            <span style={{ display: 'inline-flex' }}>
              <Item.Header as={!this.handleOnCheck(unit) && this.hasClickAccess(unit.statusID) ? Link : 'span'} to={`/projects/${unit.projectID}/units/${unit.id}/${source ? `?source=${source}` : ''}`}>
                {unit.reference}&nbsp;
              </Item.Header>
              {/* CPI-1230 (D-D5): one column, two names - Malaysia's "Bumi" and Vietnam's
                  "Foreign restricted". The chip follows the unit screen's label. */}
              {unit.isBumi && <Label size="mini">{unitQuotaChipLabel(this.props.auth, t)}</Label>}
              {unit.statusID === 'delist' && unit.delistOnHold && <Icon className="unit-list_on-hold-icon" name="pause circle outline" size="large" />}
            </span>
            <br />
            {
              isMobile &&
              <SizeSuffix
                size={unit.size}
                suffix={unit.project.sizeSuffix}
                isVietnam={isVietnam}
              />
            }
            {
              isMobile && <br />
            }
            {
              isMobile && (spaFullNumber(unit) > 1 ?
                <LoanAmount
                  projectCurrencies={unit.project.projectCurrency}
                  format="0,000,000.00"
                  amount={spaFullNumber(unit)}
                  prefix={<CurrencySymbol />}
                />
              : '-')
            }
            {
              project && project.activeBookingsInUnits && isMobile &&
              <p>{t('Active Bookings')}: {this.countActiveBooking(unit)}</p>
            }
          </Table.Cell>
          <Table.Cell className="mobile-hide">
            {unit.projectUnitLayout.name}
          </Table.Cell>
          <Table.Cell className="mobile-hide">
            {
              spaFullNumber(unit) > 1 ?
                <LoanAmount
                  projectCurrencies={unit.project.projectCurrency}
                  format="0,000,000.00"
                  amount={spaFullNumber(unit)}
                  prefix={<CurrencySymbol />}
                />
              : '-'
            }
          </Table.Cell>
          <Table.Cell className="mobile-hide">
            <SizeSuffix
              size={unit.size}
              suffix={unit.project.sizeSuffix}
              isVietnam={isVietnam}
            />
          </Table.Cell>
          {
            facilities && facilities.length > 0 ?
            projectUnitSpecifications.filter(opt =>
              facilities.some(qf => qf === opt.id))
              .map(f => (
                <Table.Cell
                  key={f.id}
                  title={f.description}
                  collapsing={f.id === 'view'}
                >
                  {
                    unit &&
                    unit.specifications &&
                    unit.specifications.some(s => s.name === f.name) ?
                    unit.specifications.find(s => s.name === f.name).value : '-'
                  }
                </Table.Cell>
              )) : null
          }
          <Table.Cell className="mobile-hide">
            <SizeSuffix
              size={unit.landArea}
              suffix={unit.project ? unit.project.sizeSuffix : null}
              isVietnam={isVietnam}
            />
          </Table.Cell>
          <Table.Cell width={2} className="mobile-hide capitalize">
            {this.checkStatusID(unit)}
          </Table.Cell>
          {
            this.isHQorSuperAdmin() &&
            this.isUnitAvailable() &&
            this.isProjectPublishToMP() && (
              <Table.Cell collapsing textAlign="center">
                {
                 unit.statusID === 'new' && (
                 <Checkbox
                   toggle
                   disabled={mpToggleLoading}
                   onChange={(e, d) => {
                     e.preventDefault();
                     this.handleMPToggle(d, unit.id);
                     this.debouncedMPToggle(unit);
                   }}
                   checked={unit.isPublishedToMP}
                 />
                 )
               }
              </Table.Cell>
            )
          }
          {
            this.hasVirtualTour() ? (
              <Table.Cell collapsing textAlign="center">
                {
                  (unit.virtualTourURL !== '' || (unit.projectUnitLayout && unit.projectUnitLayout.virtualTourURL !== '')) ? (
                    <Button
                      as="a"
                      href={unit.virtualTourURL || (unit.projectUnitLayout ? unit.projectUnitLayout.virtualTourURL : '')}
                      compact
                      color="teal"
                      icon="street view"
                      disabled={this.handleOnCheck(unit)}
                      target="_blank"
                      rel="noopener noreferrer"
                    />
                  ) : null
                }
              </Table.Cell>
            ) : null
          }
          {
            project && project.activeBookingsInUnits && !isMobile && (
              <Table.Cell collapsing textAlign="center">
                {this.countActiveBooking(unit)}
              </Table.Cell>
            )
          }
          {
            this.hasAccess() ? (
              <Table.Cell collapsing textAlign="center">
                {(!isMobile && this.canDelete(unit) && (this.props.auth.allowEditUnitDetails || this.props.auth.allowEditUnitPrice)) &&
                  <Button
                    color="red"
                    disabled={loading}
                    compact
                    icon
                    title={t('Delete', { ns: TRANSLATION_FILES.translation })}
                    onClick={e => this.handleDelete(e, unit)}
                  >
                    <Icon name="trash" />
                  </Button>
                }
              </Table.Cell>
            ) : null
          }
        </Table.Row>
      )) : (
        <Table.Row>
          <Table.Cell colSpan="100%" textAlign="center">
            {loading && <Loader active inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>}
            {
              !loading && (this.props.notFoundNode || <p>{`${t('No units found')}.`}</p>)
            }
          </Table.Cell>
        </Table.Row>
      )
    );
  }
  render() {
    const {
      count, limit, offset, loading, currentPage, globalSettings,
    } = this.state;
    const query = decodeSearch(this.props.location.search);
    const { t } = this.props;
    const countryCode = this.props.auth && this.props.auth.company && this.props.auth.company.countryCode;
    const { ascending: areaSortAscending, descending: areaSortDescending } = getAreaSortLabels(countryCode);
    const sortItems = [
      {
        text: 'Unit No. Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'project_unit.reference',
        sortDirection: 'asc',
      },
      {
        text: 'Unit No. Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'project_unit.reference',
        sortDirection: 'desc',
      },
      {
        text: 'Unit Layout Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'project_unit_layout__name',
        sortDirection: 'asc',
      },
      {
        text: 'Unit Layout Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'project_unit_layout__name',
        sortDirection: 'desc',
      },
      {
        text: 'Selling Price Ascending',
        icon: 'sort numeric ascending',
        sortColumn: 'project_unit.spa_value',
        sortDirection: 'asc',
      },
      {
        text: 'Selling Price Descending',
        icon: 'sort numeric descending',
        sortColumn: 'project_unit.spa_value',
        sortDirection: 'desc',
      },
      {
        text: areaSortAscending,
        icon: 'sort numeric ascending',
        sortColumn: 'project_unit.size',
        sortDirection: 'asc',
      },
      {
        text: areaSortDescending,
        icon: 'sort numeric descending',
        sortColumn: 'project_unit.size',
        sortDirection: 'desc',
      },
      {
        text: 'Land Ascending',
        icon: 'sort numeric ascending',
        sortColumn: 'project_unit.land_area',
        sortDirection: 'asc',
      },
      {
        text: 'Land Descending',
        icon: 'sort numeric descending',
        sortColumn: 'project_unit.land_area',
        sortDirection: 'desc',
      },
      {
        text: 'Status Ascending',
        icon: 'sort alphabet ascending',
        sortColumn: 'project_unit.status_id',
        sortDirection: 'asc',
      },
      {
        text: 'Status Descending',
        icon: 'sort alphabet descending',
        sortColumn: 'project_unit.status_id',
        sortDirection: 'desc',
      },
    ];
    const exportItems = [
      {
        text: 'Units Excel',
        href: `${config.get('bookApiURL')}/projects/${this.props.projectID}/units/export/?${qs.stringify(Object.assign(query, {}))}`,
      },
      {
        text: 'Pricing Packages Excel',
        href: `${config.get('bookApiURL')}/projects/${this.props.projectID}/units/export/package_pricings/?${qs.stringify(Object.assign(query, {}))}`,
      },
      {
        text: 'Agency Unit Allocation',
        href: `${config.get('bookApiURL')}/projects/${this.props.projectID}/units/export/unit_allocation/?${qs.stringify(Object.assign(query, {}))}`,
      },
    ];
    const bookingsByTypes = [
      { text: t('Bookings via MHub'), value: 'mhub' },
      { text: t('Bookings outside MHub'), value: 'outside' },
    ];
    return (
      <div>
        <DeleteConfirm
          open={this.state.showDeleteConfirm}
          onClose={this.handleCancelDelete}
          onConfirm={this.handleConfirmDelete}
          name={(this.state.deleteUnitData && this.state.deleteUnitData.reference) || t('Unit')}
        />
        <Dimmer
          inverted style={{ zIndex: 20 }}
          active={loading && this.state.data.length > 0}
        >
          <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
        </Dimmer>
        {this.renderLegend()}
        <Table
          celled
          unstackable
          sortable
          structured
          className="units"
        >
          <Table.Header fullWidth>
            <Table.Row>
              <Table.HeaderCell colSpan="100%">
                <Grid columns={1} verticalAlign="middle">
                  <Grid.Column>
                    {
                      this.props.headerNode ?
                      this.props.headerNode({
                        count,
                        limit,
                        offset,
                        dataSize: this.state.data.length,
                        loading,
                        currentPage,
                        onChange: this.handleChangePage,
                      }) : (
                        <SearchFilter
                          inTable
                          hasCompareBtn={this.state.summary.newCount > 0}
                          advanceFilter={this.state.advanceFilter}
                          isLoading={loading}
                          onChange={this.handleFilterOnChange}
                          onClose={this.handleClearFilter}
                          search={this.state.search}
                          setAdvanceFilter={this.handleSetAdvanceFilter}
                          leftNav={(
                            <Header style={{ marginLeft: '0.5em', marginTop: '0.25em' }}>
                              {
                                this.state.unitStatus.length > 0 ?
                                t(UNIT_STATUSES_SIMPLE_ALL.find(status =>
                                  status.value === this.state.unitStatus[0]).text, { ns: TRANSLATION_FILES.constants })
                                : t('All', { ns: TRANSLATION_FILES.translation })
                              }
                            </Header>
                          )}
                          rightNav={(
                            <div>
                              {
                                  this.state.summary &&
                                    this.state.summary.newCount > 0 ?
                                      <Button
                                        disabled={loading}
                                        as={Link}
                                        to={`/projects/${this.props.projectID}/units/compare/`}
                                        style={{
                                          backgroundColor: '#00b5ad',
                                          color: '#fff',
                                          textShadow: 'none',
                                          backgroundImage: 'none',
                                        }}
                                      >
                                        <Icon name="clone" />
                                        <small>{t('Compare', { ns: TRANSLATION_FILES.translation })}</small>
                                      </Button>
                                    : null
                                }

                              {this.hasAccess(this.props.auth.isBranchLeader) ?
                                <SortButton
                                  loading={loading}
                                  icon="download"
                                  items={exportItems}
                                />
                                : ''
                              }
                              <SortButton
                                loading={loading}
                                items={sortItems}
                                onSort={this.handleSortData}
                              />
                            </div>
                          )}
                        >
                          <SelectListMultiple
                            filterName="facilities"
                            hasSearch
                            headerText={null}
                            onChange={this.handleFilterOnChange}
                            onClose={this.handleClearFilter}
                            options={this.state.options}
                            placeholder={t('Select Unit Specifications')}
                            value={this.state.facilities}
                            renderLabel={this.renderLabel}
                            limit={3}
                          />
                          {/* CPI-1230 (D-D5): Malaysia keeps BUMI_FILTER and its own placeholder,
                              by reference; Vietnam filters the same `isBumi` query parameter under
                              "Foreign restricted" with a Yes / No pair. Every other country still
                              has no quota filter at all (MS-5972). */}
                          {showsUnitQuotaFilter(this.props.auth) && (
                            <SelectList
                              filterName="isBumi"
                              headerText={null}
                              onChange={this.handleFilterOnChange}
                              onClose={this.handleClearFilter}
                              options={unitQuotaFilterOptions(this.props.auth, t, BUMI_FILTER)}
                              placeholder={unitQuotaFilterPlaceholder(this.props.auth, t)}
                              value={this.state.isBumi}
                            />
                          )}
                          {
                            this.hasAccess() &&
                            <SelectList
                              filterName="bookingsBy"
                              hasSearch
                              headerText={null}
                              onChange={this.handleFilterOnChange}
                              onClose={this.handleClearFilter}
                              options={bookingsByTypes}
                              placeholder={t('Bookings Type')}
                              value={this.state.bookingsBy}
                            />
                          }
                        </SearchFilter>
                      )
                    }
                  </Grid.Column>
                </Grid>
              </Table.HeaderCell>
            </Table.Row>
            <Table.Row>
              <Table.HeaderCell collapsing />
              <Table.HeaderCell
                sorted={this.cellCheckSorted(sortItems[0].sortColumn)}
                onClick={() => this.handleCellSort(sortItems[0].sortColumn)}
              >
                {t('Unit')}
                {
                  this.cellCheckSorted(sortItems[0].sortColumn) ? null :
                  <Icon
                    inverted color="grey"
                    name="sort"
                  />
                }
              </Table.HeaderCell>
              <Table.HeaderCell
                sorted={this.cellCheckSorted(sortItems[2].sortColumn)}
                onClick={() => this.handleCellSort(sortItems[2].sortColumn)}
                className="mobile-hide"
              >
                {t('Layout')}
                {
                  this.cellCheckSorted(sortItems[2].sortColumn) ? null :
                  <Icon
                    inverted color="grey"
                    name="sort"
                  />
                }
              </Table.HeaderCell>
              <Table.HeaderCell
                sorted={this.cellCheckSorted(sortItems[4].sortColumn)}
                onClick={() => this.handleCellSort(sortItems[4].sortColumn)}
                className="mobile-hide"
              >
                {
                  globalSettings && globalSettings.sellingPrice
                    ? globalSettings.sellingPrice
                    : t('Selling Price')
                }
                {
                  this.cellCheckSorted(sortItems[4].sortColumn) ? null :
                  <Icon
                    inverted color="grey"
                    name="sort"
                  />
                }
              </Table.HeaderCell>
              <Table.HeaderCell
                sorted={this.cellCheckSorted(sortItems[6].sortColumn)}
                onClick={() => this.handleCellSort(sortItems[6].sortColumn)}
                className="mobile-hide"
              >
                {getAreaLabel(t, countryCode, { short: true })}
                {
                  this.cellCheckSorted(sortItems[6].sortColumn) ? null :
                  <Icon
                    inverted color="grey"
                    name="sort"
                  />
                }
              </Table.HeaderCell>
              {
                this.state.facilities && this.state.facilities.length > 0 ?
                this.state.projectUnitSpecifications.filter(opt =>
                  this.state.facilities.some(qf => qf === opt.id))
                  .map(f => (
                    <Table.HeaderCell
                      key={f.id}
                      title={f.description}
                      collapsing={f.id === 'view'}
                    >
                      {f.shortName}
                    </Table.HeaderCell>
                  )) : null
              }
              <Table.HeaderCell
                sorted={this.cellCheckSorted(sortItems[8].sortColumn)}
                onClick={() => this.handleCellSort(sortItems[8].sortColumn)}
                className="mobile-hide"
              >
                {t('Land')}
                {
                  this.cellCheckSorted(sortItems[8].sortColumn) ? null :
                  <Icon
                    inverted color="grey"
                    name="sort"
                  />
                }
              </Table.HeaderCell>
              <Table.HeaderCell
                width={2} className="mobile-hide"
                sorted={this.cellCheckSorted(sortItems[10].sortColumn)}
                onClick={() => this.handleCellSort(sortItems[10].sortColumn)}
              >
                {t('Status')}
                {
                  this.cellCheckSorted(sortItems[10].sortColumn) ? null :
                  <Icon
                    inverted color="grey"
                    name="sort"
                  />
                }
              </Table.HeaderCell>
              {
                this.isHQorSuperAdmin() &&
                this.isProjectPublishToMP() &&
                this.isUnitAvailable() && (
                  <Table.HeaderCell collapsing>
                    {t('List on Marketplace')}
                  </Table.HeaderCell>
                )
              }
              {
                this.hasVirtualTour() ? (
                  <Table.HeaderCell collapsing>
                    {t('Virtual Tour')}
                  </Table.HeaderCell>
                ) : null
              }
              {
                this.props.project && this.props.project.activeBookingsInUnits && !this.state.isMobile && (
                  <Table.HeaderCell collapsing>
                    {t('Active Bookings')}
                  </Table.HeaderCell>
                )
              }
              {
                this.hasAccess() ? (
                  <Table.HeaderCell collapsing>
                    {
                      this.props.hideNew ? null :
                      <Button
                        as={Link}
                        fluid={!this.state.isMobile}
                        compact
                        primary
                        icon={this.state.isMobile && 'add'}
                        content={!this.state.isMobile && t('New', { ns: TRANSLATION_FILES.constants })}
                        to={this.props.addPath}
                        onClick={this.handleOnAdd}
                      />
                    }
                  </Table.HeaderCell>
                ) : null
              }
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {this.renderBody()}
          </Table.Body>
          <Table.Footer fullWidth>
            <Table.Row>
              <Table.HeaderCell colSpan="100%">
                <Grid columns={1} verticalAlign="middle">
                  <Grid.Column textAlign="center">
                    {
                      this.props.footerNode ?
                      this.props.footerNode({
                        count,
                        limit,
                        offset,
                        dataSize: this.state.data.length,
                        loading,
                        currentPage,
                        onChange: this.handleChangePage,
                      }) : (
                        <PageNav
                          currentPage={currentPage}
                          count={count}
                          limit={limit}
                          offset={offset}
                          dataSize={this.state.data.length}
                          loading={loading}
                          onChange={this.handleChangePage}
                        />
                      )
                    }
                  </Grid.Column>
                </Grid>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Footer>
        </Table>
      </div>
    );
  }
}

export default withTranslation(namespaces)(withRouter(connect(ProjectUnitsList.mapStateToProps)(ProjectUnitsList)));



// WEBPACK FOOTER //
// ./src/components/ProjectUnitsList.jsx